import { render, staticRenderFns } from "./ShowList.vue?vue&type=template&id=1310a6b4&scoped=true&"
import script from "./ShowList.vue?vue&type=script&lang=js&"
export * from "./ShowList.vue?vue&type=script&lang=js&"
import style0 from "./ShowList.vue?vue&type=style&index=0&id=1310a6b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1310a6b4",
  null
  
)

export default component.exports